import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {SplitUpsellModalProps} from '@Modals/split-upsell-modal/split-upsell-modal.types';

export const openSplitUpsellModal = (props: SplitUpsellModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SPLIT_UPSELL_MODAL,
      panelProps: props,
    })
  );
};
